import { UNIT_TAGS } from "../core/constants.js";

export const RUN_UPGRADE_RARITIES = {
  COMMON: "common",
  UNCOMMON: "uncommon",
  RARE: "rare",
  EPIC: "epic",
  MYTHIC: "mythic",
  LEGENDARY: "legendary",
};

export const RUN_UPGRADE_RARITY_ORDER = [
  RUN_UPGRADE_RARITIES.COMMON,
  RUN_UPGRADE_RARITIES.UNCOMMON,
  RUN_UPGRADE_RARITIES.RARE,
  RUN_UPGRADE_RARITIES.EPIC,
  RUN_UPGRADE_RARITIES.MYTHIC,
  RUN_UPGRADE_RARITIES.LEGENDARY,
];

export const RUN_UPGRADE_RARITY_LABELS = {
  [RUN_UPGRADE_RARITIES.COMMON]: "Common",
  [RUN_UPGRADE_RARITIES.UNCOMMON]: "Uncommon",
  [RUN_UPGRADE_RARITIES.RARE]: "Rare",
  [RUN_UPGRADE_RARITIES.EPIC]: "Epic",
  [RUN_UPGRADE_RARITIES.MYTHIC]: "Mythic",
  [RUN_UPGRADE_RARITIES.LEGENDARY]: "Legendary",
};

export const RUN_UPGRADE_RARITY_ASSETS = {
  [RUN_UPGRADE_RARITIES.COMMON]: "./assets/img/upgrade-cards/1_common.png",
  [RUN_UPGRADE_RARITIES.UNCOMMON]: "./assets/img/upgrade-cards/2_uncommon.png",
  [RUN_UPGRADE_RARITIES.RARE]: "./assets/img/upgrade-cards/3_rare.png",
  [RUN_UPGRADE_RARITIES.EPIC]: "./assets/img/upgrade-cards/4_epic.png",
  [RUN_UPGRADE_RARITIES.MYTHIC]: "./assets/img/upgrade-cards/5_mythic.png",
  [RUN_UPGRADE_RARITIES.LEGENDARY]:
    "./assets/img/upgrade-cards/6_legendary.png",
};

export const RUN_UPGRADE_DRAW_TUNING = {
  choicesPerReward: 3,
  evolutionBonusWeight: 4,
  stageRarityWeights: [
    {
      maxStage: 2,
      weights: {
        common: 70,
        uncommon: 24,
        rare: 6,
        epic: 0,
        mythic: 0,
        legendary: 0,
      },
    },
    {
      maxStage: 4,
      weights: {
        common: 52,
        uncommon: 30,
        rare: 14,
        epic: 4,
        mythic: 0,
        legendary: 0,
      },
    },
    {
      maxStage: 6,
      weights: {
        common: 38,
        uncommon: 30,
        rare: 20,
        epic: 9,
        mythic: 3,
        legendary: 0,
      },
    },
    {
      maxStage: 8,
      weights: {
        common: 28,
        uncommon: 27,
        rare: 23,
        epic: 14,
        mythic: 6,
        legendary: 2,
      },
    },
    {
      maxStage: 99,
      weights: {
        common: 20,
        uncommon: 22,
        rare: 24,
        epic: 18,
        mythic: 10,
        legendary: 6,
      },
    },
  ],
};

export const RUN_UPGRADE_SCHEDULE = {
  2: "unit",
  4: "unit",
  6: "unit",
  8: "unit",
};

export const RUN_UPGRADE_GEAR_DEFAULTS = {
  "gear-aa-kit": {
    ammoPerMap: 6,
    badgeLabel: "AA",
  },
  "gear-field-meds": {
    badgeLabel: "MED",
  },
  "gear-toolkit": {
    badgeLabel: "TLK",
  },
  "gear-flamethrower": {
    badgeLabel: "FLM",
  },
  "gear-final-transmission": {
    badgeLabel: "FIN",
  },
  "gear-scavengers": {
    badgeLabel: "SCV",
  },
  "gear-predators": {
    badgeLabel: "PRD",
  },
  "gear-blood-trail": {
    badgeLabel: "BT",
  },
  "gear-climbing-gear-1": {
    badgeLabel: "CL1",
  },
  "gear-climbing-gear-2": {
    badgeLabel: "CL2",
  },
  "gear-climbing-gear-3": {
    badgeLabel: "CL3",
  },
  "gear-pathfinder-1": {
    badgeLabel: "PF1",
  },
  "gear-pathfinder-2": {
    badgeLabel: "PF2",
  },
  "gear-patient-zero": {
    badgeLabel: "PZ",
  },
};

export const RUN_UPGRADE_EFFECT_VALUES = {
  "passive-drill": { movement: 1 },
  "passive-plating": { armor: 1 },
  "gear-aa-kit": { ammoPerMap: 6, airDamageMultiplier: 0.6 },
  "gear-field-meds": { healRatio: 0.33 },
  "combat-stims-1": { attack: 2 },
  "combat-stims-2": { attack: 3 },
  "combat-stims-3": { attack: 4 },
  "armor-plating-1": { armor: 2 },
  "armor-plating-2": { armor: 3 },
  "armor-plating-3": { armor: 4 },
  "field-repairs-1": { healRatio: 0.03, requiresNoMove: true },
  "field-repairs-2": { healRatio: 0.05, requiresNoMove: true },
  "field-repairs-3": { healRatio: 0.07, requiresNoMove: false },
  "motorized-infantry-1": { roadCostMultiplier: 0.5 },
  "motorized-infantry-2": {
    roadCostMultiplier: 0.33,
    plainCostMultiplier: 0.5,
  },
  "motorized-infantry-3": { movement: 2 },
  "shock-troops-1": { attack: 3, fullHealthOnly: true },
  "shock-troops-2": { attack: 5, fullHealthOnly: true },
  "shock-troops-3": { attack: 5 },
  "entrench-1": { armor: 3 },
  "entrench-2": { armor: 3, attack: 3 },
  "entrench-3": { armor: 4, attack: 4, range: 2 },
  "pack-mules-1": { staminaMax: 20 },
  "pack-mules-2": { staminaMax: 20, ammoMax: 2 },
  "pack-mules-3": { staminaMax: 20, ammoMax: 2, movement: 1 },
  "bayonet-charge": { movement: 1, killRequired: true },
  "overclocked-engines-1": { movement: 1 },
  "overclocked-engines-2": { movement: 2 },
  "siege-package-1": { range: 1, movement: -2 },
  "siege-package-2": { range: 1, movement: -1 },
  "siege-package-3": { range: 1, attack: 5, movement: -1 },
  "heavy-payload-1": { attack: 4, staminaMax: -20 },
  "heavy-payload-2": { attack: 6, staminaMax: -20 },
  "heavy-payload-3": { attack: 7, staminaMax: -10 },
  "afterburners-1": { movement: 1, staminaCostMultiplier: 2 },
  "afterburners-2": { movement: 1 },
  "low-altitude-strike-1": { attack: 3, targetFamilies: [UNIT_TAGS.INFANTRY] },
  "low-altitude-strike-2": {
    attack: 3,
    targetFamilies: [UNIT_TAGS.INFANTRY, UNIT_TAGS.VEHICLE],
  },
  "fuel-reserve-1": { staminaMax: 10 },
  "fuel-reserve-2": { staminaMax: 20 },
  "glass-cannons-1": { attack: 4, armor: -3 },
  "glass-cannons-2": { attack: 5, armor: -2 },
  "lottery-ticket": { winChance: 0.5, cardCount: 2 },
  "experimental-ammunition-1": {
    doubleDamageChance: 0.1,
    recoilChance: 0.05,
    recoilRatio: 0.1,
  },
  "experimental-ammunition-2": {
    doubleDamageChance: 0.1,
    instantDestroyChance: 0.05,
    recoilChance: 0.05,
    recoilRatio: 0.1,
  },
  "supply-mishap-1": { attack: 3, maxHealth: -5 },
  "supply-mishap-2": { attack: 5, maxHealth: -10 },
  "supply-mishap-3": { attack: 8, maxHealth: -20 },
  "hit-and-run": { movement: 1 },
  "hold-the-line": { armor: 5 },
  "dust-storm-1": { extraAmmoChance: 0.5, ammoCost: 2 },
  "dust-storm-2": {
    extraAmmoChance: 0.75,
    ammoCost: 2,
    staminaCostMultiplier: 2,
  },
  "dust-storm-3": { extraAmmoChance: 1, ammoCost: 2, staminaCostMultiplier: 3 },
  "lone-wolf-1": { attack: 3 },
  "lone-wolf-2": { attack: 5 },
  "lone-wolf-3": { attack: 7 },
  "battle-brothers-1": { attackPerAlly: 1, armorPerAlly: 0 },
  "battle-brothers-2": { attackPerAlly: 2, armorPerAlly: 1 },
  "battle-brothers-3": {
    attackPerAlly: 2,
    armorPerAlly: 1,
    minimumRangeWithAlly: 2,
  },
  "glass-army-1": { attack: 3, armor: -4 },
  "glass-army-2": { attack: 6, armor: -7 },
  "glass-army-3": { attack: 7, armor: -5 },
  "iron-army-1": { armor: 5, movement: -1 },
  "iron-army-2": { armor: 8, movement: -2 },
  "iron-army-3": { armor: 8, staminaCostMultiplier: 2 },
  "everything-is-a-missile": { range: 1 },
  "canto-1": { movement: 1, killRequired: true },
  "canto-2": { movement: 1, killRequired: false },
  "chain-reaction-1": { damage: 10, excludeAttacker: false },
  "chain-reaction-2": { damage: 20, excludeAttacker: false },
  "chain-reaction-3": { damage: 20, excludeAttacker: true },
  "ammo-optional-1": { freeAmmoChance: 0.5 },
  "ammo-optional-2": { freeAmmoChance: 1 },
  "redline-1": { hpRatioBelow: 0.4, attack: 5, movement: 1 },
  "redline-2": { hpRatioBelow: 0.5, attack: 7, movement: 1 },
  "redline-3": { hpRatioBelow: 0.6, attack: 7, movement: 2 },
  "gear-scavengers": { healRatio: 0.03 },
  "gear-predators": { attack: 1 },
  "gear-blood-trail": { movement: 1 },
  "glass-fuel-lines": { movement: 4, turnDamageRatio: 0.15 },
  "devils-ammo": { attack: 10, selfDamageBaseChance: 0.25 },
  overconfidence: { damage: 5, incomingDamage: 10 },
  "gear-climbing-gear-1": { mountainCostDelta: -1 },
  "gear-climbing-gear-2": { mountainCost: 1 },
  "gear-climbing-gear-3": {
    mountainCost: 1,
    canCrossRidge: true,
    ridgeCost: 1,
  },
  "gear-pathfinder-1": { forestCost: 1 },
  "gear-pathfinder-2": { forestArmorMultiplier: 2 },
};

const common = RUN_UPGRADE_RARITIES.COMMON;
const uncommon = RUN_UPGRADE_RARITIES.UNCOMMON;
const rare = RUN_UPGRADE_RARITIES.RARE;
const epic = RUN_UPGRADE_RARITIES.EPIC;
const mythic = RUN_UPGRADE_RARITIES.MYTHIC;
const legendary = RUN_UPGRADE_RARITIES.LEGENDARY;

export const RUN_UPGRADE_CARD_DEFINITIONS = [
  {
    id: "passive-drill",
    type: "passive",
    name: "Drill Doctrine",
    rarity: common,
    summary: "+1 movement to all infantry.",
    effectTags: ["movement", "infantry"],
  },
  {
    id: "passive-plating",
    type: "passive",
    name: "Reactive Plating",
    rarity: common,
    summary: "+1 armor to all vehicles.",
    effectTags: ["armor", "vehicle"],
  },
  {
    id: "gear-aa-kit",
    type: "gear",
    name: "AA Kit",
    rarity: uncommon,
    repeatable: true,
    eligibleFamily: UNIT_TAGS.INFANTRY,
    summary:
      "Equip one infantry unit to attack and counter aircraft. Starts each map with 6 ammo.",
    detailLines: [
      "Can attack and counter aircraft.",
      "Deals reduced damage to air targets.",
      "Uses 6 dedicated AA shots each map.",
    ],
    effectTags: ["gear", "anti-air"],
  },
  {
    id: "gear-field-meds",
    type: "gear",
    name: "Field Medpack",
    rarity: common,
    repeatable: true,
    eligibleFamily: UNIT_TAGS.INFANTRY,
    summary:
      "Equip one infantry unit with a one-use medpack. Heals self or an adjacent infantry ally.",
    detailLines: [
      "One use per map.",
      "Heals 33% max HP, rounded up.",
      "Can target self or an adjacent infantry ally.",
    ],
    effectTags: ["gear", "heal"],
  },

  {
    id: "combat-stims-1",
    type: "passive",
    name: "Combat Stims I",
    rarity: common,
    evolutionGroup: "combat-stims",
    tier: 1,
    summary: "All units gain +2 attack.",
    effectTags: ["attack"],
  },
  {
    id: "combat-stims-2",
    type: "passive",
    name: "Combat Stims II",
    rarity: uncommon,
    evolutionGroup: "combat-stims",
    tier: 2,
    requiresCardId: "combat-stims-1",
    summary: "All units gain +3 attack.",
    effectTags: ["attack"],
  },
  {
    id: "combat-stims-3",
    type: "passive",
    name: "Combat Stims III",
    rarity: rare,
    evolutionGroup: "combat-stims",
    tier: 3,
    requiresCardId: "combat-stims-2",
    summary: "All units gain +4 attack.",
    effectTags: ["attack"],
  },
  {
    id: "armor-plating-1",
    type: "passive",
    name: "Armor Plating I",
    rarity: common,
    evolutionGroup: "armor-plating",
    tier: 1,
    summary: "All units gain +2 armor.",
    effectTags: ["armor"],
  },
  {
    id: "armor-plating-2",
    type: "passive",
    name: "Armor Plating II",
    rarity: uncommon,
    evolutionGroup: "armor-plating",
    tier: 2,
    requiresCardId: "armor-plating-1",
    summary: "All units gain +3 armor.",
    effectTags: ["armor"],
  },
  {
    id: "armor-plating-3",
    type: "passive",
    name: "Armor Plating III",
    rarity: rare,
    evolutionGroup: "armor-plating",
    tier: 3,
    requiresCardId: "armor-plating-2",
    summary: "All units gain +4 armor.",
    effectTags: ["armor"],
  },
  {
    id: "field-repairs-1",
    type: "passive",
    name: "Field Repairs I",
    rarity: uncommon,
    evolutionGroup: "field-repairs",
    tier: 1,
    summary:
      "Units heal 3% HP at the start of your turn if they did not move last turn.",
    effectTags: ["heal"],
  },
  {
    id: "field-repairs-2",
    type: "passive",
    name: "Field Repairs II",
    rarity: rare,
    evolutionGroup: "field-repairs",
    tier: 2,
    requiresCardId: "field-repairs-1",
    summary:
      "Units heal 5% HP at the start of your turn if they did not move last turn.",
    effectTags: ["heal"],
  },
  {
    id: "field-repairs-3",
    type: "passive",
    name: "Field Repairs III",
    rarity: epic,
    evolutionGroup: "field-repairs",
    tier: 3,
    requiresCardId: "field-repairs-2",
    summary: "Units heal 7% HP at the start of your turn.",
    effectTags: ["heal"],
  },

  {
    id: "motorized-infantry-1",
    type: "passive",
    name: "Motorized Infantry I",
    rarity: common,
    evolutionGroup: "motorized-infantry",
    tier: 1,
    summary: "Infantry move more efficiently on roads.",
    effectTags: ["movement", "infantry"],
  },
  {
    id: "motorized-infantry-2",
    type: "passive",
    name: "Motorized Infantry II",
    rarity: uncommon,
    evolutionGroup: "motorized-infantry",
    tier: 2,
    requiresCardId: "motorized-infantry-1",
    summary: "Infantry move more efficiently on roads and plains.",
    effectTags: ["movement", "infantry"],
  },
  {
    id: "motorized-infantry-3",
    type: "passive",
    name: "Motorized Infantry III",
    rarity: rare,
    evolutionGroup: "motorized-infantry",
    tier: 3,
    requiresCardId: "motorized-infantry-2",
    summary: "Infantry gain +2 movement.",
    effectTags: ["movement", "infantry"],
  },
  {
    id: "shock-troops-1",
    type: "passive",
    name: "Shock Troops I",
    rarity: common,
    evolutionGroup: "shock-troops",
    tier: 1,
    summary: "Infantry gain +3 attack when attacking at full health.",
    effectTags: ["attack", "infantry"],
  },
  {
    id: "shock-troops-2",
    type: "passive",
    name: "Shock Troops II",
    rarity: uncommon,
    evolutionGroup: "shock-troops",
    tier: 2,
    requiresCardId: "shock-troops-1",
    summary: "Infantry gain +5 attack when attacking at full health.",
    effectTags: ["attack", "infantry"],
  },
  {
    id: "shock-troops-3",
    type: "passive",
    name: "Shock Troops III",
    rarity: rare,
    evolutionGroup: "shock-troops",
    tier: 3,
    requiresCardId: "shock-troops-2",
    summary: "Infantry gain +5 attack.",
    effectTags: ["attack", "infantry"],
  },
  {
    id: "entrench-1",
    type: "passive",
    name: "Entrench I",
    rarity: common,
    evolutionGroup: "entrench",
    tier: 1,
    summary: "Infantry gain +3 armor while standing on sectors.",
    effectTags: ["armor", "infantry"],
  },
  {
    id: "entrench-2",
    type: "passive",
    name: "Entrench II",
    rarity: uncommon,
    evolutionGroup: "entrench",
    tier: 2,
    requiresCardId: "entrench-1",
    summary: "Infantry gain +3 armor and +3 attack while standing on sectors.",
    effectTags: ["attack", "armor", "infantry"],
  },
  {
    id: "entrench-3",
    type: "passive",
    name: "Entrench III",
    rarity: rare,
    evolutionGroup: "entrench",
    tier: 3,
    requiresCardId: "entrench-2",
    summary:
      "Infantry gain +4 armor, +4 attack, and +2 range while standing on sectors.",
    effectTags: ["attack", "armor", "range", "infantry"],
  },
  {
    id: "pack-mules-1",
    type: "passive",
    name: "Pack Mules I",
    rarity: common,
    evolutionGroup: "pack-mules",
    tier: 1,
    summary: "Infantry gain +20 stamina.",
    effectTags: ["stamina", "infantry"],
  },
  {
    id: "pack-mules-2",
    type: "passive",
    name: "Pack Mules II",
    rarity: uncommon,
    evolutionGroup: "pack-mules",
    tier: 2,
    requiresCardId: "pack-mules-1",
    summary: "Infantry gain +20 stamina and +2 ammo.",
    effectTags: ["stamina", "ammo", "infantry"],
  },
  {
    id: "pack-mules-3",
    type: "passive",
    name: "Pack Mules III",
    rarity: rare,
    evolutionGroup: "pack-mules",
    tier: 3,
    requiresCardId: "pack-mules-2",
    summary: "Infantry gain +20 stamina, +2 ammo, and +1 movement.",
    effectTags: ["stamina", "ammo", "movement", "infantry"],
  },
  {
    id: "bayonet-charge",
    type: "passive",
    name: "Bayonet Charge",
    rarity: epic,
    summary: "Infantry may move one tile after destroying a unit.",
    effectTags: ["movement", "infantry", "kill"],
  },

  {
    id: "overclocked-engines-1",
    type: "passive",
    name: "Overclocked Engines I",
    rarity: common,
    evolutionGroup: "overclocked-engines",
    tier: 1,
    summary: "Vehicles gain +1 movement.",
    effectTags: ["movement", "vehicle"],
  },
  {
    id: "overclocked-engines-2",
    type: "passive",
    name: "Overclocked Engines II",
    rarity: uncommon,
    evolutionGroup: "overclocked-engines",
    tier: 2,
    requiresCardId: "overclocked-engines-1",
    summary: "Vehicles gain +2 movement.",
    effectTags: ["movement", "vehicle"],
  },
  {
    id: "siege-package-1",
    type: "passive",
    name: "Siege Package I",
    rarity: uncommon,
    evolutionGroup: "siege-package",
    tier: 1,
    summary: "Vehicles gain +1 range but lose 2 movement.",
    effectTags: ["range", "movement", "vehicle"],
  },
  {
    id: "siege-package-2",
    type: "passive",
    name: "Siege Package II",
    rarity: rare,
    evolutionGroup: "siege-package",
    tier: 2,
    requiresCardId: "siege-package-1",
    summary: "Vehicles gain +1 range but lose 1 movement.",
    effectTags: ["range", "movement", "vehicle"],
  },
  {
    id: "siege-package-3",
    type: "passive",
    name: "Siege Package III",
    rarity: epic,
    evolutionGroup: "siege-package",
    tier: 3,
    requiresCardId: "siege-package-2",
    summary: "Vehicles gain +1 range and +5 attack but lose 1 movement.",
    effectTags: ["attack", "range", "movement", "vehicle"],
  },
  {
    id: "heavy-payload-1",
    type: "passive",
    name: "Heavy Payload I",
    rarity: common,
    evolutionGroup: "heavy-payload",
    tier: 1,
    summary: "Vehicles gain +4 attack but lose 20 stamina.",
    effectTags: ["attack", "stamina", "vehicle"],
  },
  {
    id: "heavy-payload-2",
    type: "passive",
    name: "Heavy Payload II",
    rarity: uncommon,
    evolutionGroup: "heavy-payload",
    tier: 2,
    requiresCardId: "heavy-payload-1",
    summary: "Vehicles gain +6 attack but lose 20 stamina.",
    effectTags: ["attack", "stamina", "vehicle"],
  },
  {
    id: "heavy-payload-3",
    type: "passive",
    name: "Heavy Payload III",
    rarity: rare,
    evolutionGroup: "heavy-payload",
    tier: 3,
    requiresCardId: "heavy-payload-2",
    summary: "Vehicles gain +7 attack but lose 10 stamina.",
    effectTags: ["attack", "stamina", "vehicle"],
  },

  {
    id: "afterburners-1",
    type: "passive",
    name: "Afterburners I",
    rarity: common,
    evolutionGroup: "afterburners",
    tier: 1,
    summary:
      "Aircraft gain +1 movement, but every tile moved costs double stamina.",
    effectTags: ["movement", "air"],
  },
  {
    id: "afterburners-2",
    type: "passive",
    name: "Afterburners II",
    rarity: uncommon,
    evolutionGroup: "afterburners",
    tier: 2,
    requiresCardId: "afterburners-1",
    summary: "Aircraft gain +1 movement.",
    effectTags: ["movement", "air"],
  },
  {
    id: "low-altitude-strike-1",
    type: "passive",
    name: "Low Altitude Strike I",
    rarity: uncommon,
    evolutionGroup: "low-altitude-strike",
    tier: 1,
    summary: "Aircraft deal +3 damage against infantry.",
    effectTags: ["attack", "air"],
  },
  {
    id: "low-altitude-strike-2",
    type: "passive",
    name: "Low Altitude Strike II",
    rarity: rare,
    evolutionGroup: "low-altitude-strike",
    tier: 2,
    requiresCardId: "low-altitude-strike-1",
    summary: "Aircraft deal +3 damage against infantry and vehicles.",
    effectTags: ["attack", "air"],
  },
  {
    id: "fuel-reserve-1",
    type: "passive",
    name: "Fuel Reserve I",
    rarity: common,
    evolutionGroup: "fuel-reserve",
    tier: 1,
    summary: "Aircraft gain +10 stamina.",
    effectTags: ["stamina", "air"],
  },
  {
    id: "fuel-reserve-2",
    type: "passive",
    name: "Fuel Reserve II",
    rarity: uncommon,
    evolutionGroup: "fuel-reserve",
    tier: 2,
    requiresCardId: "fuel-reserve-1",
    summary: "Aircraft gain +20 stamina.",
    effectTags: ["stamina", "air"],
  },
  {
    id: "glass-cannons-1",
    type: "passive",
    name: "Glass Cannons I",
    rarity: uncommon,
    evolutionGroup: "glass-cannons",
    tier: 1,
    summary: "Aircraft gain +4 attack and lose 3 armor.",
    effectTags: ["attack", "armor", "air"],
  },
  {
    id: "glass-cannons-2",
    type: "passive",
    name: "Glass Cannons II",
    rarity: rare,
    evolutionGroup: "glass-cannons",
    tier: 2,
    requiresCardId: "glass-cannons-1",
    summary: "Aircraft gain +5 attack and lose 2 armor.",
    effectTags: ["attack", "armor", "air"],
  },

  {
    id: "lottery-ticket",
    type: "passive",
    name: "Lottery Ticket",
    rarity: rare,
    summary:
      "50% chance to gain two random cards immediately. Otherwise, gain nothing.",
    effectTags: ["random"],
  },
  {
    id: "experimental-ammunition-1",
    type: "passive",
    name: "Experimental Ammunition",
    rarity: rare,
    evolutionGroup: "experimental-ammunition",
    tier: 1,
    summary: "Attacks can deal double damage, but may recoil.",
    effectTags: ["attack", "random"],
  },
  {
    id: "experimental-ammunition-2",
    type: "passive",
    name: "Experimental Ammunition II",
    rarity: epic,
    evolutionGroup: "experimental-ammunition",
    tier: 2,
    requiresCardId: "experimental-ammunition-1",
    summary: "Attacks can double damage, instantly destroy targets, or recoil.",
    effectTags: ["attack", "random"],
  },
  {
    id: "supply-mishap-1",
    type: "passive",
    name: "Supply Mishap I",
    rarity: common,
    evolutionGroup: "supply-mishap",
    tier: 1,
    summary: "All units gain +3 attack and lose 5 max HP.",
    effectTags: ["attack", "health"],
  },
  {
    id: "supply-mishap-2",
    type: "passive",
    name: "Supply Mishap II",
    rarity: uncommon,
    evolutionGroup: "supply-mishap",
    tier: 2,
    requiresCardId: "supply-mishap-1",
    summary: "All units gain +5 attack and lose 10 max HP.",
    effectTags: ["attack", "health"],
  },
  {
    id: "supply-mishap-3",
    type: "passive",
    name: "Supply Mishap III",
    rarity: rare,
    evolutionGroup: "supply-mishap",
    tier: 3,
    requiresCardId: "supply-mishap-2",
    summary: "All units gain +8 attack and lose 20 max HP.",
    effectTags: ["attack", "health"],
  },

  {
    id: "gear-toolkit",
    type: "gear",
    name: "Toolkit",
    rarity: rare,
    repeatable: true,
    eligibleFamily: UNIT_TAGS.INFANTRY,
    summary: "Infantry gear. Attacks corrupt enemies for 1 turn.",
    effectTags: ["gear", "status"],
  },
  {
    id: "gear-flamethrower",
    type: "gear",
    name: "Flamethrower",
    rarity: rare,
    repeatable: true,
    eligibleFamily: UNIT_TAGS.INFANTRY,
    summary: "Infantry gear. Attacks burn enemies for 1 turn.",
    effectTags: ["gear", "status"],
  },
  {
    id: "hit-and-run",
    type: "passive",
    name: "Hit And Run",
    rarity: rare,
    summary: "Air units can move one tile after attacking.",
    effectTags: ["movement", "air"],
  },
  {
    id: "hold-the-line",
    type: "passive",
    name: "Hold The Line",
    rarity: uncommon,
    summary: "Units gain +5 armor while adjacent to allies.",
    effectTags: ["armor", "position"],
  },
  {
    id: "dust-storm-1",
    type: "passive",
    name: "Dust Storm I",
    rarity: uncommon,
    evolutionGroup: "dust-storm",
    tier: 1,
    summary: "Enemy units have a 50% chance of using 2 ammo per attack.",
    effectTags: ["enemy", "ammo"],
  },
  {
    id: "dust-storm-2",
    type: "passive",
    name: "Dust Storm II",
    rarity: rare,
    evolutionGroup: "dust-storm",
    tier: 2,
    requiresCardId: "dust-storm-1",
    summary:
      "Enemy units have a 75% chance of using 2 ammo per attack and use 2 stamina per tile moved.",
    effectTags: ["enemy", "ammo", "stamina"],
  },
  {
    id: "dust-storm-3",
    type: "passive",
    name: "Dust Storm III",
    rarity: epic,
    evolutionGroup: "dust-storm",
    tier: 3,
    requiresCardId: "dust-storm-2",
    summary: "Enemy units use 2 ammo per attack and 3 stamina per tile moved.",
    effectTags: ["enemy", "ammo", "stamina"],
  },

  {
    id: "lone-wolf-1",
    type: "passive",
    name: "Lone Wolf I",
    rarity: common,
    evolutionGroup: "lone-wolf",
    tier: 1,
    summary: "Units gain +3 attack if no ally is adjacent.",
    effectTags: ["attack", "position"],
  },
  {
    id: "lone-wolf-2",
    type: "passive",
    name: "Lone Wolf II",
    rarity: uncommon,
    evolutionGroup: "lone-wolf",
    tier: 2,
    requiresCardId: "lone-wolf-1",
    summary: "Units gain +5 attack if no ally is adjacent.",
    effectTags: ["attack", "position"],
  },
  {
    id: "lone-wolf-3",
    type: "passive",
    name: "Lone Wolf III",
    rarity: rare,
    evolutionGroup: "lone-wolf",
    tier: 3,
    requiresCardId: "lone-wolf-2",
    summary: "Units gain +7 attack if no ally is adjacent.",
    effectTags: ["attack", "position"],
  },
  {
    id: "battle-brothers-1",
    type: "passive",
    name: "Battle Brothers I",
    rarity: common,
    evolutionGroup: "battle-brothers",
    tier: 1,
    summary: "Units gain +1 attack for every adjacent ally.",
    effectTags: ["attack", "position"],
  },
  {
    id: "battle-brothers-2",
    type: "passive",
    name: "Battle Brothers II",
    rarity: uncommon,
    evolutionGroup: "battle-brothers",
    tier: 2,
    requiresCardId: "battle-brothers-1",
    summary: "Units gain +2 attack and +1 armor for every adjacent ally.",
    effectTags: ["attack", "armor", "position"],
  },
  {
    id: "battle-brothers-3",
    type: "passive",
    name: "Battle Brothers III",
    rarity: rare,
    evolutionGroup: "battle-brothers",
    tier: 3,
    requiresCardId: "battle-brothers-2",
    summary:
      "Units gain +2 attack and +1 armor per adjacent ally. Adjacent units have at least 2 range.",
    effectTags: ["attack", "armor", "range", "position"],
  },
  {
    id: "glass-army-1",
    type: "passive",
    name: "Glass Army I",
    rarity: uncommon,
    evolutionGroup: "glass-army",
    tier: 1,
    summary: "All units gain +3 attack and lose 4 armor.",
    effectTags: ["attack", "armor"],
  },
  {
    id: "glass-army-2",
    type: "passive",
    name: "Glass Army II",
    rarity: rare,
    evolutionGroup: "glass-army",
    tier: 2,
    requiresCardId: "glass-army-1",
    summary: "All units gain +6 attack and lose 7 armor.",
    effectTags: ["attack", "armor"],
  },
  {
    id: "glass-army-3",
    type: "passive",
    name: "Glass Army III",
    rarity: epic,
    evolutionGroup: "glass-army",
    tier: 3,
    requiresCardId: "glass-army-2",
    summary: "All units gain +7 attack and lose 5 armor.",
    effectTags: ["attack", "armor"],
  },
  {
    id: "iron-army-1",
    type: "passive",
    name: "Iron Army I",
    rarity: uncommon,
    evolutionGroup: "iron-army",
    tier: 1,
    summary: "All units gain +5 armor and lose 1 movement.",
    effectTags: ["armor", "movement"],
  },
  {
    id: "iron-army-2",
    type: "passive",
    name: "Iron Army II",
    rarity: rare,
    evolutionGroup: "iron-army",
    tier: 2,
    requiresCardId: "iron-army-1",
    summary: "All units gain +8 armor and lose 2 movement.",
    effectTags: ["armor", "movement"],
  },
  {
    id: "iron-army-3",
    type: "passive",
    name: "Iron Army III",
    rarity: epic,
    evolutionGroup: "iron-army",
    tier: 3,
    requiresCardId: "iron-army-2",
    summary: "All units gain +8 armor but use 2 stamina per tile moved.",
    effectTags: ["armor", "stamina"],
  },

  {
    id: "everything-is-a-missile",
    type: "passive",
    name: "Everything Is A Missile",
    rarity: mythic,
    summary: "All units gain +1 range.",
    effectTags: ["range"],
  },
  {
    id: "canto-1",
    type: "passive",
    name: "Canto I",
    rarity: epic,
    evolutionGroup: "canto",
    tier: 1,
    summary: "Units may move one tile after destroying an enemy.",
    effectTags: ["movement", "kill"],
  },
  {
    id: "canto-2",
    type: "passive",
    name: "Canto II",
    rarity: mythic,
    evolutionGroup: "canto",
    tier: 2,
    requiresCardId: "canto-1",
    summary: "Units may move one tile after attacking an enemy.",
    effectTags: ["movement"],
  },
  {
    id: "chain-reaction-1",
    type: "passive",
    name: "Chain Reaction I",
    rarity: rare,
    evolutionGroup: "chain-reaction",
    tier: 1,
    summary:
      "Destroyed enemy vehicles explode for 10 damage in adjacent tiles, including the attacker.",
    effectTags: ["explosion", "vehicle"],
  },
  {
    id: "chain-reaction-2",
    type: "passive",
    name: "Chain Reaction II",
    rarity: epic,
    evolutionGroup: "chain-reaction",
    tier: 2,
    requiresCardId: "chain-reaction-1",
    summary:
      "Destroyed enemy vehicles explode for 20 damage in adjacent tiles, including the attacker.",
    effectTags: ["explosion", "vehicle"],
  },
  {
    id: "chain-reaction-3",
    type: "passive",
    name: "Chain Reaction III",
    rarity: mythic,
    evolutionGroup: "chain-reaction",
    tier: 3,
    requiresCardId: "chain-reaction-2",
    summary:
      "Destroyed enemy vehicles explode for 20 damage in adjacent tiles, excluding the attacker.",
    effectTags: ["explosion", "vehicle"],
  },
  {
    id: "ammo-optional-1",
    type: "passive",
    name: "Ammo? Optional. I",
    rarity: rare,
    evolutionGroup: "ammo-optional",
    tier: 1,
    summary: "Attacks have a 50% chance of consuming no ammo.",
    effectTags: ["ammo", "random"],
  },
  {
    id: "ammo-optional-2",
    type: "passive",
    name: "Ammo? Optional. II",
    rarity: epic,
    evolutionGroup: "ammo-optional",
    tier: 2,
    requiresCardId: "ammo-optional-1",
    summary: "Attacks no longer consume ammo.",
    effectTags: ["ammo"],
  },
  {
    id: "redline-1",
    type: "passive",
    name: "Redline I",
    rarity: uncommon,
    evolutionGroup: "redline",
    tier: 1,
    summary: "Units below 40% HP gain +5 attack and +1 movement.",
    effectTags: ["attack", "movement", "health"],
  },
  {
    id: "redline-2",
    type: "passive",
    name: "Redline II",
    rarity: rare,
    evolutionGroup: "redline",
    tier: 2,
    requiresCardId: "redline-1",
    summary: "Units below 50% HP gain +7 attack and +1 movement.",
    effectTags: ["attack", "movement", "health"],
  },
  {
    id: "redline-3",
    type: "passive",
    name: "Redline III",
    rarity: epic,
    evolutionGroup: "redline",
    tier: 3,
    requiresCardId: "redline-2",
    summary: "Units below 60% HP gain +7 attack and +2 movement.",
    effectTags: ["attack", "movement", "health"],
  },
  {
    id: "gear-final-transmission",
    type: "gear",
    name: "Final Transmission",
    rarity: legendary,
    repeatable: true,
    summary:
      "When this unit dies, it immediately performs one final attack as if it had 100% HP.",
    effectTags: ["gear", "death"],
  },

  {
    id: "gear-scavengers",
    type: "gear",
    name: "Scavengers",
    rarity: uncommon,
    repeatable: true,
    summary: "Gain 3% HP after destroying an enemy.",
    effectTags: ["gear", "heal", "kill"],
  },
  {
    id: "gear-predators",
    type: "gear",
    name: "Predators",
    rarity: rare,
    repeatable: true,
    summary:
      "Gain +1 attack after destroying an enemy. Persists through stages.",
    effectTags: ["gear", "attack", "kill"],
  },
  {
    id: "gear-blood-trail",
    type: "gear",
    name: "Blood Trail",
    rarity: epic,
    repeatable: true,
    summary: "Gain +1 movement after destroying an enemy. Only once per map.",
    effectTags: ["gear", "movement", "kill"],
  },

  {
    id: "glass-fuel-lines",
    type: "passive",
    name: "Glass Fuel Lines",
    rarity: rare,
    summary: "Vehicles gain +4 movement and take 15% damage every turn.",
    effectTags: ["movement", "damage", "vehicle"],
  },
  {
    id: "devils-ammo",
    type: "passive",
    name: "Devil's Ammo",
    rarity: epic,
    summary: "+10 attack. Chance based on luck to damage self instead.",
    effectTags: ["attack", "random"],
  },
  {
    id: "overconfidence",
    type: "passive",
    name: "Overconfidence",
    rarity: rare,
    summary: "Units deal +5 damage and take +10 damage.",
    effectTags: ["attack", "damage"],
  },

  {
    id: "gear-climbing-gear-1",
    type: "gear",
    name: "Climbing Gear I",
    rarity: common,
    repeatable: true,
    evolutionGroup: "climbing-gear",
    tier: 1,
    eligibleFamily: UNIT_TAGS.INFANTRY,
    summary: "Infantry gear. Mountains cost 1 less movement than normal.",
    effectTags: ["gear", "movement", "infantry"],
  },
  {
    id: "gear-climbing-gear-2",
    type: "gear",
    name: "Climbing Gear II",
    rarity: uncommon,
    repeatable: true,
    evolutionGroup: "climbing-gear",
    tier: 2,
    requiresCardId: "gear-climbing-gear-1",
    eligibleFamily: UNIT_TAGS.INFANTRY,
    summary: "Infantry gear. Mountains cost the same movement as roads.",
    effectTags: ["gear", "movement", "infantry"],
  },
  {
    id: "gear-climbing-gear-3",
    type: "gear",
    name: "Climbing Gear III",
    rarity: rare,
    repeatable: true,
    evolutionGroup: "climbing-gear",
    tier: 3,
    requiresCardId: "gear-climbing-gear-2",
    eligibleFamily: UNIT_TAGS.INFANTRY,
    summary: "Infantry gear. Infantry can cross mountains and ridges.",
    effectTags: ["gear", "movement", "infantry"],
  },
  {
    id: "gear-pathfinder-1",
    type: "gear",
    name: "Pathfinder I",
    rarity: uncommon,
    repeatable: true,
    evolutionGroup: "pathfinder",
    tier: 1,
    summary: "Gear. Forests cost the same movement as roads.",
    effectTags: ["gear", "movement"],
  },
  {
    id: "gear-pathfinder-2",
    type: "gear",
    name: "Pathfinder II",
    rarity: rare,
    repeatable: true,
    evolutionGroup: "pathfinder",
    tier: 2,
    requiresCardId: "gear-pathfinder-1",
    summary: "Gear. Forest armor bonus is doubled.",
    effectTags: ["gear", "armor"],
  },
  {
    id: "gear-patient-zero",
    type: "gear",
    name: "Patient Zero",
    rarity: legendary,
    repeatable: true,
    summary: "Gear. Attacks cause Zombified status.",
    effectTags: ["gear", "status"],
  },

  {
    id: "noop-heal-on-level-up",
    type: "passive",
    name: "Heal On Level Up",
    rarity: common,
    hidden: true,
    noOp: true,
    summary: "Placeholder for the unnamed idea: heal upon level up.",
    effectTags: ["placeholder"],
  },
  {
    id: "noop-xp-boost",
    type: "passive",
    name: "XP Boost",
    rarity: common,
    hidden: true,
    noOp: true,
    summary: "Placeholder for the unnamed idea: earn more XP.",
    effectTags: ["placeholder"],
  },
  {
    id: "noop-stat-up-boost",
    type: "passive",
    name: "Stat Up Boost",
    rarity: common,
    hidden: true,
    noOp: true,
    summary: "Placeholder for the unnamed idea: increase chances for stat ups.",
    effectTags: ["placeholder"],
  },
  {
    id: "noop-kill-stat-temporary",
    type: "passive",
    name: "Temporary Kill Stats",
    rarity: common,
    hidden: true,
    noOp: true,
    summary:
      "Placeholder for the unnamed idea: gain stats per kill, resets after map clear.",
    effectTags: ["placeholder"],
  },
  {
    id: "noop-ally-death-xp",
    type: "passive",
    name: "Ally Death XP",
    rarity: common,
    hidden: true,
    noOp: true,
    summary:
      "Placeholder for the unnamed idea: when an ally dies, all other allies gain XP.",
    effectTags: ["placeholder"],
  },
];
